// extracted by mini-css-extract-plugin
module.exports = {"cardHead":"ActiveCustomers_cardHead__1xz4K","cardTitle":"ActiveCustomers_cardTitle__2LOC1","chart":"ActiveCustomers_chart__1hmMK"};